/**
 * 全局音频播放管理器
 * 确保同一时间只有一条语音在播放（单例模式）
 */
export class AudioPlaybackManager {
  /** 当前正在播放的播放器 ID */
  private currentPlayerId: string | null = null;
  /** 已注册的播放器停止回调 */
  private listeners: Map<string, () => void> = new Map();

  /**
   * 注册播放器实例
   * @param id - 播放器唯一标识
   * @param onStop - 当该播放器需要被停止时调用的回调
   * @returns 取消注册函数
   */
  register(id: string, onStop: () => void): () => void {
    this.listeners.set(id, onStop);
    return () => {
      this.listeners.delete(id);
      if (this.currentPlayerId === id) {
        this.currentPlayerId = null;
      }
    };
  }

  /**
   * 请求播放权限，会自动停止当前正在播放的其他播放器
   * @param id - 请求播放的播放器 ID
   */
  requestPlay(id: string): void {
    // 如果有其他播放器正在播放，先停止它
    if (this.currentPlayerId && this.currentPlayerId !== id) {
      const stopFn = this.listeners.get(this.currentPlayerId);
      if (stopFn) {
        stopFn();
      }
    }
    this.currentPlayerId = id;
  }

  /**
   * 通知播放已停止
   * @param id - 已停止播放的播放器 ID
   */
  notifyStop(id: string): void {
    if (this.currentPlayerId === id) {
      this.currentPlayerId = null;
    }
  }
}

/** 全局单例 */
export const audioPlaybackManager = new AudioPlaybackManager();
